import {getBaseAPIV2FloorplanUrl, getBaseUrl} from './utils/api.js'

export default Object.freeze({
  baseUrl: getBaseUrl(),
  baseAPIV2FloorplanUrl: getBaseAPIV2FloorplanUrl(),
  tradexUrl: 'https://tradex-services.com',
  mapUrl: 'https://maps.tradex-services.com'
})
